module.exports = __webpack_public_path__ + "static/media/unsplash-royal.9325f488.svg";